import { applySnapshot, getSnapshot, types as t } from 'mobx-state-tree';

const CancelReasonType = t.model('CancelReasonType', {
  id: t.string,
  name: t.string,
  description: t.string,
});

export const CancelReasonTypesModel = t
  .model('CancelReasonTypesModel', {
    list: t.array(CancelReasonType),
  })
  .actions((self) => {
    let initialState = {};
    return {
      afterCreate() {
        initialState = getSnapshot(self);
      },
      reset() {
        applySnapshot(self, initialState);
      },
    };
  });

export default CancelReasonTypesModel;
